import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { ApolloProvider } from '@apollo/react-hooks'
import { AppContextProvider } from 'AppContext'
import * as serviceWorker from 'serviceWorker'
import { version } from '../package.json'
import client from 'apollo'
import App from 'App'
import 'react-quill/dist/quill.snow.css'

console.log(`App Version: ${version}`)

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.debug) {
      console.log('Debug from SW!', event.data.debug)
      const debugLogs = JSON.parse(localStorage.getItem('debugLogs')) || []
      debugLogs.push({ timestamp: Date.now(), message: event.data.debug })
      localStorage.setItem('debugLogs', JSON.stringify(debugLogs))
    }
  })
}

const AutoRefresh = () => {
  useEffect(() => {
    let idleTime = 0
    const idleLimit = 900

    const resetIdleTimer = () => {
      idleTime = 0
    }

    const checkIdleTime = () => {
      idleTime++
      if (idleTime >= idleLimit) {
        window.location.reload()
      }
    }

    window.addEventListener('mousemove', resetIdleTimer)
    window.addEventListener('keydown', resetIdleTimer)
    window.addEventListener('scroll', resetIdleTimer)
    window.addEventListener('touchstart', resetIdleTimer)

    const idleInterval = setInterval(checkIdleTime, 1000)

    return () => {
      clearInterval(idleInterval)
      window.removeEventListener('mousemove', resetIdleTimer)
      window.removeEventListener('keydown', resetIdleTimer)
      window.removeEventListener('scroll', resetIdleTimer)
      window.removeEventListener('touchstart', resetIdleTimer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
let hasReloaded = false

const configuration = {
  onUpdate: (registration) => {
    if (registration && registration.waiting && !hasReloaded) {
      hasReloaded = true
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload()
      })
    }
  }
}

ReactDOM.render(
  <ApolloProvider client={client}>
    <AppContextProvider>
      <AutoRefresh />
      <App />
    </AppContextProvider>
  </ApolloProvider>,
  document.getElementById('root')
)

// Register Service Worker
serviceWorker.register(configuration)
